import styled from 'styled-components';
import { RecentCampaignAlerts } from './RecentCampaignAlerts';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { SENDS_GRID_AREA, ALERTS_GRID_AREA } from './CampaignsHealthDashboard.constants';
import { CampaignsHealthMetrics } from './CampaignsHealthMetrics';
import {
  DESKTOP_ALERTS_WIDTH_VALUE,
  MAX_HEALTH_CONTENT_HEIGHT,
} from 'modules/missionControl/constants';

export const Container = styled.div`
  width: 100%;
  max-height: ${MAX_HEALTH_CONTENT_HEIGHT};
  display: grid;
  grid-template-columns: minmax(0, auto) minmax(0, ${pxToRem(DESKTOP_ALERTS_WIDTH_VALUE)});
  grid-template-rows: 1fr;
  grid-gap: ${spacing.threeQuarter};
  grid-template-areas: "${SENDS_GRID_AREA} ${ALERTS_GRID_AREA}";

  @media only screen and (max-width: 1260px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto ${MAX_HEALTH_CONTENT_HEIGHT};
    max-height: none;
    grid-template-areas: "${SENDS_GRID_AREA}" "${ALERTS_GRID_AREA}";
  }
`;

export const CampaignsHealthDashboard = () => {
  return (
    <Container>
      <CampaignsHealthMetrics />
      <RecentCampaignAlerts />
    </Container>
  );
};
